import { Option } from "@models/clients/option";

interface OptionType {
  type: string;
  title: string;
  icon: string;
}

class OptionsManagerController implements angular.IOnInit {
  public optionTypes: OptionType[] = [
    { type: 'assetclass', title: 'Asset Class', icon: 'category' },
    { type: 'connectioncategory', title: 'Connection Category', icon: 'link' },
    { type: 'contacttitle', title: 'Contact Title', icon: 'title' },
    { type: 'currency', title: 'Currency', icon: 'attach_money' },
    { type: 'employmentstatus', title: 'Employment Status', icon: 'work' },
    { type: 'externalsource', title: 'External Account Source Types', icon: 'account_balance' },
    { type: 'geographicallocation', title: 'Geographical Location', icon: 'public' },
    { type: 'jurisdiction', title: 'Jurisdiction', icon: 'gavel' },
    { type: 'managementfeetype', title: 'Management Fee Type', icon: 'attach_money' },
    { type: 'portfoliofrequency', title: 'Portfolio Frequency', icon: 'schedule' },
    { type: 'portfoliomodeofcorrespondence', title: 'Portfolio Mode of Correspondence', icon: 'mail' },
    { type: 'portfoliopreferredlocation', title: 'Portfolio Preferred Location', icon: 'location_on' },
    { type: 'portfolioreportingtitle', title: 'Portfolio Reporting Titles', icon: 'description' },
    { type: 'portfolioreportingtype', title: 'Portfolio Reporting Type', icon: 'assessment' },
    { type: 'riskrating', title: 'Risk Ratings', icon: 'warning' },
    { type: 'setupfee', title: 'Setup Fee', icon: 'payment' },
    { type: 'signatoryregime', title: 'Signatory Regime', icon: 'how_to_reg' },
    { type: 'spouse', title: 'Spouse', icon: 'favorite' },
    { type: 'standingorder', title: 'Standing Order', icon: 'schedule' },
    { type: 'standingorderfrequency', title: 'Standing Order Frequency', icon: 'repeat' },
    { type: 'transactionactivitytype', title: 'Transaction Activity Type', icon: 'swap_horiz' },
    { type: 'typeofclient', title: 'Type of Client', icon: 'person' },
    { type: 'typeofportfolio', title: 'Type of Portfolio', icon: 'folder' },
    { type: 'typeofrelatedparty', title: 'Type of Related Party', icon: 'group' }
  ];

  public readonly columns = Object.freeze([
    { key: 'title', label: 'Option Type', width: 'col-md-12' }
  ]);

  public displayColumns = false;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private $rootScope: angular.IRootScopeService
  ) {}

  public $onInit(): void {
    // Component initialization
  }

  public openOptionModal(params: { item: OptionType }): void {
    const optionType = params.item;
    const tempScope = this.$rootScope.$new() as any;
    tempScope.optionType = optionType;

    this.$mdDialog
      .show({
        template: '<md-dialog flex="60" aria-label="Options Dialog"><option-edit-modal option-type="optionType"></option-edit-modal></md-dialog>',
        clickOutsideToClose: false,
        scope: tempScope
      })
      .then((result) => {
        if (result) {
          // Option was saved, could refresh if needed
          console.log('Options updated:', result);
        }
      });
  }
}

export const optionsManager = {
  template: require("./options-manager.html"),
  controller: OptionsManagerController,
  bindings: {}
};



// WEBPACK FOOTER //
// ./src/components/options-manager/options-manager.ts